const prefix = '[APPLICATION]';

export const REDIRECT_CALL_REQUEST = `${prefix} REDIRECT_CALL_REQUEST`;
export const REDIRECT_CALL_SUCCESS = `${prefix} REDIRECT_CALL_SUCCESS`;
